<template>
  <div class="about">
    <div class="top-placeholder"></div>
    <div class="banner rel">
      <div class="abs imamge"></div>
    </div>
    <div class="">
      <div class="g3 title1">公司介绍</div>
      <div class="g6 f20 mt10">广州匠心游戏自创建以来，一直致力于小游戏的研发和运营，成员包括阿里、网易、4399等游戏厂商的优秀人才</div>
      <div class="g6 f20 mt5">我们崇尚扁平化管理，本着对产品专注、专业、高效、创新的态度，立志做出有趣、有品质、有理念的三有产品</div>
    </div>
    <div class="introduce cl">
      <!-- <img class="game-imamge" src="../assets/03/zhaopian.jpg" alt=""> -->
    </div>
    <div class="">
      <div class="g3 title1">团队介绍</div>
      <div class="g6 f20 mt10 text1">我们的成员都是本着一颗热爱游戏和追求极致的心，致力于打造一系列独特魅力的高品质游戏。</div>
      <div class="g6 f20 mt10 text1">品牌定制团队核心人员，来自国内排名前三小程序小游戏开发团队，有着三年小程序、小游戏、APP、PC web等多端多平台开发经验，积累大量品牌定制经验，合作品牌案例：钱袋子保卫战（中国人民银行）、坦克3合1（KFC）、欢乐农场主（腾讯公益：电商扶贫）、 蓝臻宝宝乐游游（美赞臣）、安儿宝开心牧场（安儿宝）
、 B Surf 冲浪小精灵（Burberry（博柏利））、麦当劳游戏（麦当劳）、直通天际（迪拜塔旅游商业合作）、萌鸡小队画画（ IP精品战略合作）、（超级飞侠冲冲冲）IP精品战略合作等。</div>
    </div>
    <div class="introduce cl">
      <img class="game-imamge" src="../assets/03/renyuan1.jpg" alt="">
    </div>
    <PageFooter msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
// @ is an alias to /src
import PageFooter from '@/components/PageFooter.vue'

export default {
  name: 'home',
  components: {
    PageFooter
  }
}
</script>

<style lang="scss" scoped>
.text1 {
  width: 1000px;
  margin: 0 auto;
  text-align: left;
  text-indent: 40px;
}
.top-placeholder {
  width: 100%;
  height: 100px;
}
.banner {
  width: 100%;
  height: 500px;
  .imamge {
    width: 100%;
    height: 500px;
    background: url('../assets/03/banner.jpg') no-repeat center center / 1920px;
  }
}
.title1 {
  margin-top: 100px;
  font-size: 40px;
}
.introduce {
  margin-top: 45px;
}
.ceo {
  padding-bottom: 100px;
}
.ceo-introduce {
  width: 700px;
}
/* 团队 */
.team {
  width: 100%;
  height: 480px;
  .title3 {
    padding-top: 60px;
    font-size: 40px;
  }
  .subtitle {
    color: #eeeeee;
  }
  .team-item-box {
    margin-top: 40px;
    width: 1102px;
  }
  .item {
    height: 100px;
    margin:30px 18px 10px 18px;
    .game-imamge {
      width: 200px;
      height: 250px;
      display: block;
    }
    .desc1 {
      margin: 12px 0 0 0;
    }
    .game-desc {
      margin-left: 28px;
    }
    .normal{
      height: 100px;
    }
    .normal1{
      height: 100px;
      line-height: 100px
    }
  }
}
</style>
